import { useTranslation } from 'react-i18next';

import { ListItem, IconButton, Tooltip } from '@treezor/design-system';

import { BrandingIcon } from '@/ui-kit/BrandingIcon/BrandingIcon';
import { IUser, UserTypes } from '@/features/user/store/user.model';

interface IParentProps {
  parentUser: IUser;
  redirectToParent: (userId: number, shouldOpenNewTab?: boolean) => void;
}
export function Parent({ parentUser, redirectToParent }: IParentProps) {
  const { t } = useTranslation();
  return (
    <div className="w-full rounded-200 border-[2px] p-5 flex g-4 border-primary justify-between items-center">
      <ListItem
        title={
          parentUser.userTypeId === UserTypes.naturalPerson
            ? `${parentUser.firstname} ${parentUser.lastname}`
            : parentUser.legalName
        }
        information={`${t('pages.dashboard.createUser.form.userID')}: ${parentUser.userId}`}
        avatar={<BrandingIcon name={parentUser.userTypeId === UserTypes.naturalPerson ? 'user' : 'enterprise'} />}
      />
      <Tooltip
        variant="primary"
        placement="top"
        messageContent={t('pages.dashboard.createUser.form.seeUserProfile')}
        contentClassName="min-w-[115px]"
      >
        <IconButton icon="chevron_right" onClick={() => redirectToParent(parentUser.userId, true)} className="mr-0" />
      </Tooltip>
    </div>
  );
}
